export default import.meta.ROLLUP_FILE_URL_Pfiv8SoUfQMa_7dTVCKlpQ;